import React from "react";

// Unfortunately we must add default consent settings before the initialization of the GTM script, hence this IIFE helmet component.

interface InitialConsentSettingsProperties {
    helmetComponent: React.ComponentType;
    ad_storage?: "denied" | "granted";
    ad_user_data?: "denied" | "granted";
    ad_personalization?: "denied" | "granted";
    analytics_storage?: "denied" | "granted";
    functionality_storage?: "denied" | "granted";
    personalization_storage?: "denied" | "granted";
    security_storage?: "denied" | "granted";
    wait_for_update?: number;
}

const InitialConsentSettings = ({
    helmetComponent: Helmet,
    ad_storage = "denied",
    ad_user_data = "denied",
    ad_personalization = "denied",
    analytics_storage = "denied",
    functionality_storage = "denied",
    personalization_storage = "denied",
    security_storage = "granted",
    wait_for_update = 500,
}: InitialConsentSettingsProperties) => {
    return (
        <Helmet>
            <script>
                {`(function() {
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    
                    gtag('consent', 'default', {
                        ad_storage: "${ad_storage}",
                        ad_user_data: "${ad_user_data}",
                        ad_personalization: "${ad_personalization}",
                        analytics_storage: "${analytics_storage}",
                        functionality_storage: "${functionality_storage}",
                        personalization_storage: "${personalization_storage}",
                        security_storage: "${security_storage}",
                        wait_for_update: ${wait_for_update},
                    });

                    gtag('set', 'ads_data_redaction', true)
                })()`}
            </script>
        </Helmet>
    );
};
export default InitialConsentSettings;
